import { styled } from '@mui/material/styles';
import { Box, Chip } from '@mui/material';

export const DashboardContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
});

export const FilterRow = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
});

export const StatusChip = styled(Chip)(({ statuscolor }) => ({
    fontWeight: 600,
    backgroundColor: statuscolor || '#e0e0e0',
    color: '#fff',
}));
